import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Container from 'components/ui/Container';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import { useFormik } from 'formik';
import useToggle from 'hooks/useToggle';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  IEvaluationTrainee,
  useCreateEvaluationTraineeMutation,
  useDeleteEvaluationTraineeMutation,
  useUpdateEvaluationTraineeMutation
} from 'redux/reducers/assignmentEvalutaion';
import {
  IEvaluationCriteriaFormInput,
  IInviteEvaluatorFormInput,
  useCreateEvaluationsCriteriaMutation,
  useCreateInviteEvaluatorMutation
} from 'redux/reducers/FeedbackEvaluation';
import AddTableData from '../NewEvaluation';
import AssignmentTableData from '../NewEvaluation/Assignment/AssignmentList';
import AddEvaluationForm from '../NewEvaluation/EvaluationForms/AddEvaluation';
import {
  EvaluationTraineeInitialValues,
  EvaluationTraineeSchemaValidation
} from '../NewEvaluation/schema';
import EditCriteriaForm from './EvaluationForms/EditCriteriaForm';
import {
  EvaluationCriteriaInitialValues,
  EvaluationCriteriaSchemaValidations,
  InviteEvaluatorInitialValues
} from './schema';
import FeedbackForm from './tables/FeedbackForm';
import EvaluationCriteria from './tables/EvaluationCriteria';
import AddCriteriaForm from './EvaluationForms/AddCriteriaForm';

const FeedbackEvaluation = () => {
  const [feedbackModal, setFeedbackModal] = useToggle(false);
  const [evaluatorModal, setEvaluatorModal] = useToggle(false);

  

  const [addcriteriaModal, setAddCriteriaModal] = useToggle(false);

  const [addEvaluationModal, setAddEvaluationModal] = useToggle(false);

  const [deleteModal, toggleDeleteModal] = useToggle(false);
  const [feedbackInitialFormState, setFeedbackInitialForm] = useState<IEvaluationCriteriaFormInput>(
    EvaluationCriteriaInitialValues
  );
  const [initialEvaluatorFormState, setInitialEvaluatorForm] = useState<IInviteEvaluatorFormInput>(
    InviteEvaluatorInitialValues
  );

  const [createInviteEvaluator, { isLoading: isCreatingInviteEvaluator }] =
    useCreateInviteEvaluatorMutation();

  const [deleteFeedbackEvaluationCriteria, { isLoading: isDeletingEvaluationCriteria }] =
    useDeleteEvaluationTraineeMutation();
  const [createFeedbackEvaluationsCriteria, { isLoading: isCreatingEvaluationsCriteria }] =
    useCreateEvaluationsCriteriaMutation();

  const [createFeedbackEvaluationCriteria, { isLoading: isCreatingEvaluationCriteria }] =
    useCreateEvaluationTraineeMutation();

  const [updateFeedbackEvaluationCriteria, { isLoading: isUpdatingEvaluationCriteria }] =
    useUpdateEvaluationTraineeMutation();

  const [deletingEvaluationState, setDeletingEvaluation] = useState<IEvaluationTrainee | null>(
    null
  );
  const { id } = useParams();
  const navigate = useNavigate();

   const formik = useFormik({
    enableReinitialize: true,
    validationSchema: EvaluationCriteriaSchemaValidations,
    initialValues: feedbackInitialFormState,

    onSubmit: (values, { resetForm }) => {
      let executeFunc = updateFeedbackEvaluationCriteria;

      let b = values.routine_evaluation.map((evaluator: any) => {
        return {
          id: evaluator.id === undefined ? null : evaluator.id,
          evaluator: evaluator.evaluator_details.id.toString()
        };
      });

      const newValues = { ...values, routine_evaluation: [...b] };
      const payload = {
        id: newValues.id,
        evaluation_criteria_detail: newValues.evaluation_criteria_detail,
        routine: newValues.routine,
        max_marks: newValues.max_marks,
        routine_evaluation: newValues.routine_evaluation
      };

      executeFunc(payload)
        .unwrap()
        .then((data: any) => {
          toast.success('Updated Successfully');
          resetForm();
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          setFeedbackModal();
        })
        .catch((err: any) => {
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          resetForm();
          // toast.error(err.data.errors.question);
          // toast.error(err.data.errors.question_np);
        });
      setEvaluatorModal();
      resetForm();
    }
  });
  

  const addAssignmentformik = useFormik({
    enableReinitialize: true,
    validationSchema: EvaluationTraineeSchemaValidation,
    initialValues: EvaluationTraineeInitialValues,

    onSubmit: (values, { resetForm }) => {
      let executeFunc = values?.id
        ? updateFeedbackEvaluationCriteria
        : createFeedbackEvaluationCriteria;

      executeFunc(values)
        .unwrap()
        .then((data: any) => {
          toast.success('Created Successfully');
          resetForm();
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          setFeedbackModal();
        })
        .catch((err: any) => {
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          resetForm();
        });
      setAddEvaluationModal();
      resetForm();
    }
  });

  const addEvaluationformik = useFormik({
    enableReinitialize: true,
    validationSchema: EvaluationTraineeSchemaValidation,
    initialValues: EvaluationTraineeInitialValues,

    onSubmit: (values, { resetForm }) => {
      let executeFunc = values?.id
        ? updateFeedbackEvaluationCriteria
        : createFeedbackEvaluationCriteria;

      executeFunc(values)
        .unwrap()
        .then((data: any) => {
          toast.success('Created Successfully');
          resetForm();
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          setFeedbackModal();
        })
        .catch((err: any) => {
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          resetForm();
        });
      setAddEvaluationModal();
      resetForm();
    }
  });
  const addCriteriaformik = useFormik({
    enableReinitialize: true,
    validationSchema: EvaluationCriteriaSchemaValidations,
    initialValues: feedbackInitialFormState,

    onSubmit: (values, { resetForm }) => {
      let executeFunc = createFeedbackEvaluationsCriteria;

      let b = values.routine_evaluation.map((evaluator: any) => {
        return { evaluator: evaluator.value };
      });

      const newValues = { ...values, routine_evaluation: [...b] };

      const payload = {
        evaluation_criteria_detail: newValues.evaluation_criteria_detail,
        routine: newValues.routine,
        max_marks: newValues.max_marks,
        routine_evaluation: newValues.routine_evaluation
      };

      executeFunc(payload)
        .unwrap()
        .then((data: any) => {
          toast.success('Created Successfully');
          resetForm();
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          // setFeedbackModal();
          setAddCriteriaModal()
        })
        .catch((err: any) => {
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          resetForm();
        });
      setAddEvaluationModal();
      resetForm();
    }
  });
  const onDeleteConfirmEvaluationCriteria = () => {
    selectedData &&
      deleteFeedbackEvaluationCriteria(selectedData)
        .unwrap()
        .then((data: any) => {
          toast.success('Deleted Successfully');
          setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          toggleDeleteModal();
        })
        .catch((err: any) => {
          toast.error('Error');
        });
  };
  const onFFEditClicked = (data: any) => {
    alert(data);
  };
  const onFFDeleteClicked = (data: any) => {
    setFeedbackInitialForm(data);
    toggleDeleteModal();
  };
  const onFFView = (data: any) => {
    var tabValue;
    if (data === 'Daily Session feedback') {
      tabValue = 1;
    } else if (data === 'Module feedback') {
      tabValue = 0;
    } else if (data === 'Lunch feedback') {
      tabValue = 2;
    } else {
      tabValue = 3;
    }
    navigate(`/feedback-mgmt/routinefeedback/${id}/tab=${tabValue}`);
  };
  const [selectedData, setSelectedData] = useState<any>();
  const onEditClicked = (data: any) => {
    setSelectedData(data);
    setAddEvaluationModal(true);
  };

    const onEditCeriteriaClicked = (data: any) => {
    setEvaluatorModal();
    setFeedbackInitialForm(data);
  };
  const onDeleteClicked = (data: IEvaluationTrainee) => {
    setSelectedData(data);
    toggleDeleteModal();
  };
  const onView = (data: any) => {
    alert('view clicked');
  };
  const [showAddQuestionModal, setshowAddQuestionModal] = useToggle(false);
  const onAddQuestions = (data: any) => {
    setSelectedData(data);
    setshowAddQuestionModal(!showAddQuestionModal);
  };

  return (
    <Container title="">
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirmEvaluationCriteria}
        title="Delete Confirmations"
        isLoading={isDeletingEvaluationCriteria}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>

      <div className="row ">
        <div className="col-lg-12" style={{ paddingRight: '50px', paddingLeft: '50px' }}>
          <div
            style={{
              color: '#1269B3',
              fontWeight: '500',
              fontSize: '16px',
              marginBottom: '10px',
              marginTop: '25px'
            }}>
            Feedback Form
          </div>
          <FeedbackForm
            onEditClicked={onFFEditClicked}
            onDeleteClicked={onFFDeleteClicked}
            onViewClicked={onFFView}
          />
        </div>
      </div>
      <hr style={{ marginTop: '20px', color: 'rgb(114 99 99' }}></hr>
      <div className="row mt-4">
        <div className="col-lg-12" style={{ paddingRight: '50px', paddingLeft: '50px' }}>
          <div
            style={{ color: '#1269B3', fontWeight: '500', fontSize: '24px', marginBottom: '16px' }}>
            Evaluation
          </div>

          <AddTableData
            tableHeaders={() => (
              <>
                <PrimaryButton
                  title="Add Evaluation"
                  iconName="ri-add-line align-bottom me-1"
                  onClick={() => {
                    setSelectedData(undefined);
                    setAddEvaluationModal();
                    // setFeedbackInitialForm(EvaluationCriteriaInitialValues);
                  }}
                  type="button"
                />
              </>
            )}
            onEditClicked={onEditClicked}
            onDeleteClicked={onDeleteClicked}
            onViewClicked={onView}
            onAddQuestions={onAddQuestions}
          />
          <EvaluationCriteria
            tableHeaders={() => (
              <>
                <PrimaryButton
                  title="Add Criteria"
                  iconName="ri-add-line align-bottom me-1"
                  onClick={() => {
                    setAddCriteriaModal();
                    setFeedbackInitialForm(EvaluationCriteriaInitialValues);
                  }}
                  type="button"
                />
              </>
            )}
            onEditClicked={onEditCeriteriaClicked}
            onDeleteClicked={onDeleteClicked}
            onViewClicked={onView}
          />
        </div>
      </div>
      {/* <form onSubmit={formik.handleSubmit}>
        <Modal
          title="Edit Criteria"
          isModalOpen={evaluatorModal}
          closeModal={setEvaluatorModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <PrimaryButton
                title="Update"
                type="submit"
                isLoading={isUpdatingEvaluationCriteria}
              />

              <SecondaryButton
                onClick={setEvaluatorModal}
                title="Discard"
                isLoading={isUpdatingEvaluationCriteria}
              />
            </div>
          )}>
          <EditCriteriaForm formik={formik} />
        </Modal>
      </form> */}

      <form onSubmit={addEvaluationformik.handleSubmit}>
        <Modal
          title="Add Evaluation"
          isModalOpen={addEvaluationModal}
          closeModal={setAddEvaluationModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <PrimaryButton
                title="Save"
                type="submit"
                isLoading={isUpdatingEvaluationCriteria || isCreatingEvaluationCriteria}
              />

              <SecondaryButton
                onClick={setAddEvaluationModal}
                title="Discard"
                isLoading={isUpdatingEvaluationCriteria || isCreatingEvaluationCriteria}
              />
            </div>
          )}>
          <AddEvaluationForm selectedData={selectedData} formik={addEvaluationformik} />
        </Modal>
      </form>
      {/* <form onSubmit={addAssignmentformik.handleSubmit}> */}
      <Modal
        title="Questions"
        isModalOpen={showAddQuestionModal}
        closeModal={setshowAddQuestionModal}
        renderFooter={() => (
          <div className="hstack gap-2 justify-content-end">
            <SecondaryButton onClick={setshowAddQuestionModal} title="Discard" />
          </div>
        )}>
        <AssignmentTableData selectedData={selectedData} />
      </Modal>
      {/* </form> */}


      <form onSubmit={formik.handleSubmit}>
        <Modal
        modalSize='modal-xl'
          title="Edit Criteria"
          isModalOpen={evaluatorModal}
          closeModal={setEvaluatorModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <PrimaryButton
                title="Update"
                type="submit"
                isLoading={isUpdatingEvaluationCriteria}
              />

              <SecondaryButton
                onClick={setEvaluatorModal}
                title="Discard"
                isLoading={isUpdatingEvaluationCriteria}
              />
            </div>
          )}
        >
          <EditCriteriaForm formik={formik} />
        </Modal>
      </form>
      <form onSubmit={addCriteriaformik.handleSubmit}>
        <Modal
          title="Add Criteria"
          modalSize='modal-xl'
          isModalOpen={addcriteriaModal}
          closeModal={setAddCriteriaModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <PrimaryButton
                title="Save"
                type="submit"
                isLoading={isUpdatingEvaluationCriteria || isCreatingEvaluationCriteria}
              />

              <SecondaryButton
                onClick={setAddCriteriaModal}
                title="Discard"
                isLoading={isUpdatingEvaluationCriteria || isCreatingEvaluationCriteria}
              />
            </div>
          )}
        >
          <AddCriteriaForm formik={addCriteriaformik} />
        </Modal>
      </form>
    </Container>
  );
};

export default FeedbackEvaluation;
